"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoanEventType = exports.LoanInterestDaysYear = exports.LoanInterestDaysMonth = exports.LoanFinancingType = exports.LoanStatus = void 0;
var LoanStatus;
(function (LoanStatus) {
    LoanStatus["DRAFT"] = "draft";
    LoanStatus["ACTIVE"] = "active";
    LoanStatus["ENDED"] = "ended";
})(LoanStatus = exports.LoanStatus || (exports.LoanStatus = {}));
var LoanFinancingType;
(function (LoanFinancingType) {
    LoanFinancingType["CAPITAL"] = "capital";
    LoanFinancingType["MAINTENANCE"] = "maintenance";
    LoanFinancingType["UNREALIZED_MAINTENANCE"] = "unrealized_maintenance";
})(LoanFinancingType = exports.LoanFinancingType || (exports.LoanFinancingType = {}));
var LoanInterestDaysMonth;
(function (LoanInterestDaysMonth) {
    LoanInterestDaysMonth["THIRTY_DAYS"] = "30";
    LoanInterestDaysMonth["ACTUAL_OF_MONTH"] = "actual-of-month";
})(LoanInterestDaysMonth = exports.LoanInterestDaysMonth || (exports.LoanInterestDaysMonth = {}));
var LoanInterestDaysYear;
(function (LoanInterestDaysYear) {
    LoanInterestDaysYear["THREE_SIXTY"] = "360";
    LoanInterestDaysYear["THREE_SIXTY_FIVE"] = "365";
    LoanInterestDaysYear["ACTUAL_OF_YEAR"] = "actual-of-year";
})(LoanInterestDaysYear = exports.LoanInterestDaysYear || (exports.LoanInterestDaysYear = {}));
var LoanEventType;
(function (LoanEventType) {
    LoanEventType["LOAN_DRAW"] = "loan_draw";
    LoanEventType["LOAN_BANK_REPAYMENT"] = "loan_bank_repayment";
    LoanEventType["INTEREST_CHANGE"] = "interest_change";
    LoanEventType["SHAREGROUP_DEBT_REPAYMENT"] = "sharegroup_debt_repayment";
    LoanEventType["COLLECTED_SHAREGROUP_BANK_REPAYMENT"] = "collected_sharegroup_bank_repayment";
    LoanEventType["STARTING_BALANCE"] = "starting_balance";
    LoanEventType["STARTING_SURPLUS_OR_DEFICIT"] = "starting_surplus_or_deficit";
    LoanEventType["STARTING_COLLECTED_PAYMENTS"] = "starting_collected_payments";
})(LoanEventType = exports.LoanEventType || (exports.LoanEventType = {}));
